import React, { useRef, useEffect, useState } from 'react';
import './App.css';
import Footer from './Footer';

const images = [
  './images/dabulle1.webp',
  './images/dabulle2.webp',
  './images/dabulle3.webp',
  './images/dabulle4.webp',
  './images/sigiriya.png',
];

const TravelForm = () => {
  const carouselRef = useRef(null);
  const [lang, setLang] = useState('en');

  useEffect(() => {
    const scrollInterval = setInterval(() => {
      if (carouselRef.current) {
        const container = carouselRef.current;
        const maxScrollLeft = container.scrollWidth - container.clientWidth;

        if (container.scrollLeft >= maxScrollLeft) {
          container.scrollLeft = 0;
        } else {
          container.scrollLeft += 260;
        }
      }
    }, 2000);

    return () => clearInterval(scrollInterval);
  }, []);

const content = {
  en: `Dambulla is a historic town in Sri Lanka’s Central Province, best known for its magnificent Dambulla Cave Temple a UNESCO World Heritage Site featuring over 150 Buddha statues and stunning wall paintings inside five sacred caves. It’s a major stop in Sri Lanka’s Cultural Triangle.

Nearby, you’ll find the iconic Sigiriya Rock Fortress, often called the “Eighth Wonder of the World,” with ancient royal gardens and spectacular views. Adventure seekers can climb Pidurangala Rock for a quieter hike and panoramic scenery.

Other highlights include:
• Iron Wood Forest (Namal Uyana) – a pink quartz mountain and ancient monastery site.
• Minneriya National Park – famous for elephant gatherings near the Minneriya Tank.
• Kandalama Lake – peaceful and perfect for birdwatching or boat rides.
• Rangiri Dambulla International Stadium – nestled in scenic surroundings.

Dambulla serves as a serene cultural hub that offers nature, history, and spiritual richness all in one location.`,

  zh: `丹布勒是斯里兰卡中部省一个历史悠久的小镇，以宏伟的丹布勒石窟寺而闻名——这是联合国教科文组织的世界遗产，拥有150多尊佛像和五个神圣石窟内令人惊叹的壁画。它是斯里兰卡文化三角的重要一站。

附近有著名的锡吉里耶狮子岩，被誉为“世界第八大奇迹”，拥有古代皇家花园和壮丽景观。冒险者可攀登毗邻的皮杜兰加拉岩，享受宁静的徒步旅行与全景风光。

其他亮点包括：
• 铁木森林（Namal Uyana）——一座粉红石英山和古代寺庙遗址。
• 米内里亚国家公园——以旱季成群结队的大象闻名。
• 坎达拉玛湖——宁静的环境，适合观鸟与泛舟。
• 兰吉里丹布勒国际体育场——位于风景如画的环境中。

丹布勒是一个融合自然、历史与精神文化的宁静之地，为游客提供丰富多样的体验。`
};


  return (
    <div className="travel-form-container2">
      {/* Row 1 */}
      <div className="row row-one2">
        <div className="col image-col2">
          <img src="./images/sigiriya.png"  className="travel-image2" />
          <img src="./images/dabulle3.webp" className="travel-image2" />
        </div>

        <div className="col content-col2">
          <h2>Dambulla</h2>

          {/* Language Toggle Button */}
          <div style={{ textAlign: 'right', marginBottom: '10px' }}>
            <button onClick={() => setLang(lang === 'en' ? 'zh' : 'en')} style={{ padding: '8px 16px', borderRadius: '6px', border: 'none', backgroundColor: '#967969', color: 'white', cursor: 'pointer' }}>
              {lang === 'en' ? '切换到中文' : 'Switch to English'}
            </button>
          </div>

          {/* Paragraph */}
          <p style={{ whiteSpace: 'pre-line' }}>{content[lang]}</p>
        </div>
      </div>

      {/* Row 2 - Auto Carousel */}
     <div className="carousel-container2">
       <div className="carousel-heading-column">
         <h2 className="carousel-heading">Explore Dambulla</h2>
         <p className="carousel-subheading">Step into history at Dambulla, home to sacred cave temples, ancient art, and spiritual legends of Sri Lanka.</p>
       </div>

       <div className="carousel2" ref={carouselRef}>
         {images.map((imgSrc, index) => (
           <img key={index} src={imgSrc} className="carousel-image2" />
         ))}
       </div>
     </div>


      {/* Footer */}
      <Footer />
    </div>
  );
};

export default TravelForm;

